import { loadable } from '@change/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'change-password',
		path: '/account_settings/change_password',
		component: loadable(
			async () => import(/* webpackChunkName: "pages/account_settings_change_password" */ './index'),
			{
				exportName: 'ChangePassword',
				fallback: Loading,
			},
		),
		restrictedAccess: {
			authOnly: true,
		},
		frame: true,
		ssr: {
			// switch this to true to enable SSR
			enabled: true,
			seo: false,
		},
	},
];
